export default __webpack_public_path__ + "static/media/lapu-lapu.7c039cc7.jpg";